export const PORTRAIT =
  "https://customer-assets-v7afamib.emergentagent.net/job_30a51fad-ed5a-4b2d-9f06-bf2114221dd0/artifacts/ql5f6yev_fotome.jpeg";

export const ABOUT_PHOTO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_holding-hub-7/artifacts/3y61js3l_5250ec2b-e28a-4190-9768-5a2ee5733279.png";

export const IMG = {
  boardroom: "https://images.unsplash.com/photo-1779700210487-a01758a3c55a?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  wine: "https://images.unsplash.com/photo-1553361371-9b22f78e8b1d",
  car: "https://images.pexels.com/photos/14231681/pexels-photo-14231681.jpeg",
  mountains: "https://images.unsplash.com/photo-1704192257598-be5cb6e710e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  signage: "https://customer-assets-wrfwihn1.emergentagent.net/job_holding-hub-7/artifacts/4b97f4l5_ChatGPT%20Image%2029%20lug%202026%2C%2016_14_24.png",
};

export const NAV = [
  { label: "Chi sono", href: "#chi-sono" },
  { label: "Advisory", href: "#advisory" },
  { label: "Academy", href: "#academy" },
  { label: "Prodotti", href: "#prodotti" },
  { label: "Insights", href: "#insights" },
  { label: "Lifestyle", href: "#lifestyle" },
  { label: "Contatti", href: "#contatti" },
];

export const BUSINESS_UNITS = [
  { n: "01", title: "Executive Advisory", desc: "Affiancamento strategico a CEO e leadership team su crescita, governance e trasformazione." },
  { n: "02", title: "Board Advisory", desc: "Ruoli da consigliere indipendente e supporto ai Consigli di Amministrazione." },
  { n: "03", title: "Fractional CIO", desc: "Direzione IT e digitale a tempo parziale per aziende in evoluzione tecnologica." },
  { n: "04", title: "Fractional CRO", desc: "Guida del rischio d'impresa e dei framework di Enterprise Risk Management." },
  { n: "05", title: "AI Governance", desc: "Policy, controlli e responsabilità per un'adozione dell'AI sicura e conforme." },
  { n: "06", title: "Digital Governance", desc: "Modelli operativi digitali, dati e cybersecurity a livello di board." },
  { n: "07", title: "Family Business", desc: "Governance, continuità e passaggio generazionale per imprese familiari." },
];

export const MANIFESTO = [
  { n: "01", title: "Autorevolezza", body: "Costruire una voce riconosciuta su AI Governance, rischio e trasformazione digitale, al servizio dei board." },
  { n: "02", title: "Impatto", body: "Trasformare la complessità in decisioni chiare: framework, dashboard e strumenti che generano valore misurabile." },
  { n: "03", title: "Ecosistema", body: "Un'unica piattaforma che integra consulenza, formazione, prodotti digitali e community executive." },
  { n: "04", title: "Visione", body: "Intravedere e costruire una prospettiva nuova scalabile, indipendente e imprenditoriale." },
];

export const ACADEMY = [
  { title: "AI Governance for Boards", level: "Executive", weeks: "6 settimane", desc: "Il percorso completo per portare l'AI in Consiglio con controlli e responsabilità chiare." },
  { title: "Enterprise Risk Master", level: "Advanced", weeks: "8 settimane", desc: "Costruire un framework ERM moderno, dalla mappatura dei rischi al reporting al board." },
  { title: "Digital Transformation Leadership", level: "Executive", weeks: "6 settimane", desc: "Guidare la trasformazione digitale come Fractional CIO, tra tecnologia e persone." },
  { title: "Family Business Governance", level: "Intermediate", weeks: "5 settimane", desc: "Governance e continuità per imprese familiari che vogliono durare nel tempo." },
];

export const PRODUCTS = [
  { lookup: "ai_governance_toolkit", name: "AI Governance Toolkit", price: "€149", regular: "€390", launch: true, type: "Toolkit + Framework", desc: "Policy, checklist e framework pronti all'uso per governare l'adozione dell'AI." },
  { lookup: "board_advisory_playbook", name: "Board Advisory Playbook", price: "€249", type: "Template + Dashboard", desc: "Il manuale operativo del consigliere: agende, dashboard e board pack templates." },
  { lookup: "executive_ai_assessment", name: "Executive AI Assessment", price: "€390", regular: "€599", launch: true, type: "Assessment + Workshop", desc: "Valutazione della maturità AI della tua organizzazione con roadmap prioritizzata." },
];

export const MEMBERSHIP = {
  plans: [
    { id: "monthly", lookup: "executive_club_monthly", price: "€39", period: "/ mese", note: "Abbonamento mensile · disdici quando vuoi" },
    { id: "yearly", lookup: "executive_club_yearly", price: "€390", period: "/ anno", note: "Abbonamento annuale · due mesi in omaggio" },
  ],
  perks: [
    "Community privata di leader e board member",
    "Masterclass mensili con ospiti",
    "Accesso anticipato a prodotti e framework",
    "Sessioni di Q&A e per advisory",
    "Newsletter premium e insight riservati",
  ],
};

export const INSIGHTS = [
  { tag: "AI Governance", title: "Perché ogni board ha bisogno di una AI policy nel 2026", read: "6 min" },
  { tag: "Enterprise Risk", title: "Dal rischio alla resilienza: il nuovo mandato del CRO", read: "8 min" },
  { tag: "Digital", title: "Fractional CIO: la leadership tecnologica che scala", read: "5 min" },
  { tag: "Family Business", title: "Governance familiare: costruire per la prossima generazione", read: "7 min" },
];

export const SPEAKING = [
  { event: "AI Governance Summit", role: "Keynote Speaker", place: "Milano" },
  { event: "Board Leadership Forum", role: "Panelist", place: "Roma" },
  { event: "Digital Risk Conference", role: "Keynote Speaker", place: "Bologna" },
];
